import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { PrivateRouteState } from './privateRouteState';
import { useRouteModel } from './routeHooks';
import { AuthFlowResponseType } from '../services/auth/authFlowSchema';
import { AuthFlowResponseInterpreter } from '../components/auth';
import { LoadPage } from '../components';
import { TRACE } from '../core/debug/debugMacros';

type Props = {
  children: ReactNode;
};

export const PrivateRoute = observer((props: Props) => {
  const { children } = props;

  const model = useRouteModel((kernel) => new PrivateRouteState(kernel.store));

  TRACE(model, `render()`, { props, model });

  const { flowResponse } = model;
  if (model.isLoading)
    return <LoadPage />

  switch (flowResponse?.responseType) {
    case AuthFlowResponseType.Authorized:
      break;

    default:
      return (
        <AuthFlowResponseInterpreter
          response={flowResponse}
          error={model.error} />
      );
  }

  return <>{children}</>;
});
